import React from 'react';

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HeroIntro from './Components/HeroIntro';

function App() {
  return (  
    
<Router>
<Routes>
  <Route path="/" element={
            <>           
            <HeroIntro/>
            </>
          } />
</Routes>
</Router>
  );
}

export default App;
